import { Box, useTheme } from '@mui/material';

import { Typography } from '@zendesk/forethought-elements';

export const CodeBlock = ({
  content,
  title,
}: {
  content: string;
  title: string;
}) => {
  const { palette } = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
      }}
    >
      <Typography variant='font11'>{title}</Typography>
      <Box
        sx={{
          bgcolor: palette.colors.black,
          border: `1px solid ${palette.colors.slate[200]}`,
          borderRadius: '8px',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
          padding: '16px',
        }}
      >
        <Box
          component='pre'
          sx={{
            color: 'white',
            fontSize: '14px',
            margin: 0,
            overflowX: 'auto',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
          }}
        >
          <code>{content}</code>
        </Box>
      </Box>
    </Box>
  );
};
